import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, isRef as _isRef, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "flex items-center border-b-2 py-2" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-700" }
const _hoisted_4 = { class: "text-sm text-gray-500" }
const _hoisted_5 = { class: "ml-auto" }
const _hoisted_6 = { class: "filter-switch flex items-center h-10 p-1 space-x-1 bg-gray-100 rounded-md font-semibold text-blue-600" }
const _hoisted_7 = ["name", "id", "onUpdate:modelValue", "onChange"]
const _hoisted_8 = ["for"]
const _hoisted_9 = ["name", "id", "onUpdate:modelValue", "onChange"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "pt-2" }
const _hoisted_12 = { class: "mt-4 shadow-none h-16 w-full border border-black rounded-lg p-4" }
const _hoisted_13 = {
  role: "status",
  style: {"display":"inline-block","margin-left":"47%","margin-top":"5%"}
}
const _hoisted_14 = ["aria-hidden"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_19 = { style: {"padding-bottom":"5em"} }
const _hoisted_20 = { class: "tableWrapper" }
const _hoisted_21 = { class: "tableHeader" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = { class: "centrato" }
const _hoisted_24 = { class: "centrato" }

import CalculatorDescription from "../components/CalculatorDescription.vue";
import BaseOutput from "../components/BaseOutput.vue";
import CalcoloScoresInput from "../components/CalcoloScoresInput.vue";
import BaseButtons from "../components/BaseButtons.vue";

import { Score } from "@/../../EshJSLib/models/patient";
import { saveScore } from "../../../../../EshJSLib/services/scoreServices";

import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";

import { ref, reactive, onMounted } from "vue";

import AlertModal from "@/components/AlertModal.vue";
import { Modal } from "flowbite-vue";

import '../calcolatriceMedica.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'MeldScore',
  emits: ["cancel"],
  setup(__props, { emit }) {

onMounted(async () => {
  store.fetchMeldScoresRelatedData();
});

const store = patientStore();
const { patient } = storeToRefs(store);

const mostraSalva = ref(false);

let creatinina = ref();
let bilirubina = ref();
let inr = ref();
let sodio = ref();

let puntegioTotale = ref();
let stimaDiMorte = ref();

const isShowModal = reactive({
  alert: false,
});



const loading = ref(false);
let alertStatus = ref('');

function updatePoints(option) {
  creatinina.value = option.isSelected === "1" ? 4 : "";
}

function calculator() {
  creatinina.value = creatinina.value > 4 ? 4 : creatinina.value < 1 ? 1 : creatinina.value;
  bilirubina.value = bilirubina.value < 1 ? 1 : bilirubina.value;
  inr.value = inr.value < 1 ? 1 : inr.value;
  sodio.value = sodio.value < 125 ? 125 : sodio.value > 137 ? 137 : sodio.value;

  puntegioTotale.value = Math.round(
    10 *
    (0.957 * Math.log(creatinina.value) +
      0.378 * Math.log(bilirubina.value) +
      1.12 * Math.log(inr.value) +
      0.643)
  );

  puntegioTotale.value =
    puntegioTotale.value > 11
      ? Math.floor(
        puntegioTotale.value +
        1.32 * (137 - sodio.value) -
        0.033 * puntegioTotale.value * (137 - sodio.value)
      ).toFixed(0)
      : puntegioTotale.value;
  puntegioTotale.value = puntegioTotale.value > 40 ? 40 : puntegioTotale.value;

  stimaDiMorte.value =
    puntegioTotale.value >= 0 && puntegioTotale.value <= 9
      ? 1.9
      : puntegioTotale.value >= 10 && puntegioTotale.value <= 19
        ? 6.0
        : puntegioTotale.value >= 20 && puntegioTotale.value <= 29
          ? 19.6
          : puntegioTotale.value >= 30 && puntegioTotale.value < 40
            ? 52.6
            : puntegioTotale.value == 40
              ? 71.3
              : stimaDiMorte.value;

    if (isNaN(puntegioTotale.value)) {
      puntegioTotale.value = "Inserire dei valori validi!";
      // NON MOSTRA IL BOTTONE
      mostraSalva.value = false;
    } else {
      // MOSTRA IL BOTTONE
      mostraSalva.value = true;
    }
}

let meldScore = {} as Score;

function saveMeldScore() {
  loading.value = true;
  try {
    meldScore.id_paziente = patient.value!.id_paziente;
    meldScore.nome_score = "meld-score";
    meldScore.valore_score = puntegioTotale.value;
    const datartn = saveScore(meldScore).then((x) => {
      alertStatus.value = 'success';
      isShowModal.alert = true;
      loading.value = false;
      puntegioTotale.value = null;
      stimaDiMorte.value = null;
      creatinina.value = null;
      bilirubina.value = null;
      inr.value = null;
      sodio.value = null;

      for (const item of store.meldScoreList) {
        item.isSelected = 0;
      }
      store.fetchMeldScoresRelatedData();
    });

  }
  catch {
    ((error) => {

      alertStatus.value = 'fail';
      isShowModal.alert = true;
      loading.value = false;
      store.fetchMeldScoresRelatedData();
      emit("cancel");
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(CalculatorDescription, {
        calculatorDescription: _ctx.$t('meldDescription')
      }, null, 8, ["calculatorDescription"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).meldScoreList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "w-60 bg-white border-b-1",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.description), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: `option-${item.id}`,
                  class: "form-radio h-4 w-4 text-indigo-600",
                  id: `no-${item.id}`,
                  value: "0",
                  "onUpdate:modelValue": ($event: any) => ((item.isSelected) = $event),
                  onChange: ($event: any) => (updatePoints(item))
                }, null, 40, _hoisted_7), [
                  [_vModelRadio, item.isSelected]
                ]),
                _createElementVNode("label", {
                  for: `no-${item.isSelected}`,
                  class: "h-8 py-1 px-2 text-sm leading-6 text-gray-600 hover:text-gray-800 rounded shadow"
                }, _toDisplayString(item.option1), 9, _hoisted_8),
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: `option-${item.id}`,
                  class: "form-radio h-4 w-4 text-indigo-600",
                  id: `yes-${item.id}`,
                  value: "1",
                  "onUpdate:modelValue": ($event: any) => ((item.isSelected) = $event),
                  onChange: ($event: any) => (updatePoints(item))
                }, null, 40, _hoisted_9), [
                  [_vModelRadio, item.isSelected]
                ]),
                _createElementVNode("label", {
                  for: `yes-${item.isSelected}`,
                  class: "h-8 py-1 px-2 text-sm leading-6 text-gray-600 hover:text-gray-800 rounded shadow"
                }, _toDisplayString(item.option2), 9, _hoisted_10)
              ])
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Creatinina'),
          type: "number",
          placeholder: "Norm: 0.7-1.3",
          modelValue: _unref(creatinina),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(creatinina) ? (creatinina).value = $event : creatinina = $event)),
          unit: "mq/dL"
        }, null, 8, ["label", "modelValue"]),
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Bilirubina'),
          type: "number",
          placeholder: "Norm: 0.3-1.9",
          modelValue: _unref(bilirubina),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(bilirubina) ? (bilirubina).value = $event : bilirubina = $event)),
          unit: "mq/dL"
        }, null, 8, ["label", "modelValue"]),
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('INR'),
          type: "number",
          placeholder: "Norm: 0.8-1.2",
          unit: "%",
          modelValue: _unref(inr),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(inr) ? (inr).value = $event : inr = $event))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(CalcoloScoresInput, {
          label: _ctx.$t('Sodio'),
          placeholder: "Norm: 136-145",
          type: "number",
          unit: "mEq/L",
          modelValue: _unref(sodio),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(sodio) ? (sodio).value = $event : sodio = $event))
        }, null, 8, ["label", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseOutput, {
          classType: "result",
          label: _ctx.$t('puntegioTotale'),
          key: "number",
          result: _unref(puntegioTotale),
          unit: ""
        }, null, 8, ["label", "result"]),
        _createVNode(BaseOutput, {
          classType: "flex uppercase",
          label: _ctx.$t('stimaMorte3Mesi'),
          key: "number",
          result: _unref(stimaDiMorte),
          unit: "%"
        }, null, 8, ["label", "result"]),
        _createVNode(BaseButtons, {
          hiddenCancellaButton: "",
          onCalculate: calculator,
          hiddenSalvaButton: !mostraSalva.value,
          onSaveResult: saveMeldScore,
          class: "mt-2 mb-2 pt-2"
        }, null, 8, ["hiddenSalvaButton"]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createElementBlock("svg", {
              "aria-hidden": !loading.value,
              class: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_17, 8, _hoisted_14)),
            _hoisted_18
          ], 512), [
            [_vShow, loading.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("table", _hoisted_20, [
          _createElementVNode("tr", _hoisted_21, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tableH1")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tableData1")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("tableData2")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).meldScores, (result) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: result.id
            }, [
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, _toDisplayString(result.created_at), 1),
              _createElementVNode("td", _hoisted_24, _toDisplayString(result.valore_score), 1)
            ]))
          }), 128))
        ])
      ]),
      (isShowModal.alert)
        ? (_openBlock(), _createBlock(_unref(Modal), {
            key: 0,
            onClose: _cache[5] || (_cache[5] = ($event: any) => {isShowModal.alert = false; _ctx.$emit('cancel')})
          }, {
            body: _withCtx(() => [
              _createVNode(AlertModal, {
                status: _unref(alertStatus),
                onCloseAlert: _cache[4] || (_cache[4] = ($event: any) => {isShowModal.alert = false; _ctx.$emit('cancel')})
              }, null, 8, ["status"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})